import { DIRECTION_TYPE, Theme } from '@mirai/ui';

export const themeDirection = (language) => {
  if (!language) return;

  const next = language === 'ar' ? DIRECTION_TYPE.RIGHT : DIRECTION_TYPE.LEFT;
  if (next !== Theme.getDirection()) Theme.setDirection(next);
};
